__turbopack_context__.v({
  "activeTab": "SalaryNegotiation-module__GBaHrq__activeTab",
  "benefitName": "SalaryNegotiation-module__GBaHrq__benefitName",
  "benefitRow": "SalaryNegotiation-module__GBaHrq__benefitRow",
  "benefitValue": "SalaryNegotiation-module__GBaHrq__benefitValue",
  "benefitsHeader": "SalaryNegotiation-module__GBaHrq__benefitsHeader",
  "benefitsTable": "SalaryNegotiation-module__GBaHrq__benefitsTable",
  "checkIcon": "SalaryNegotiation-module__GBaHrq__checkIcon",
  "checklistItems": "SalaryNegotiation-module__GBaHrq__checklistItems",
  "container": "SalaryNegotiation-module__GBaHrq__container",
  "content": "SalaryNegotiation-module__GBaHrq__content",
  "contextText": "SalaryNegotiation-module__GBaHrq__contextText",
  "copyButton": "SalaryNegotiation-module__GBaHrq__copyButton",
  "expandIcon": "SalaryNegotiation-module__GBaHrq__expandIcon",
  "expanded": "SalaryNegotiation-module__GBaHrq__expanded",
  "header": "SalaryNegotiation-module__GBaHrq__header",
  "insightIcon": "SalaryNegotiation-module__GBaHrq__insightIcon",
  "insightsList": "SalaryNegotiation-module__GBaHrq__insightsList",
  "insightsSection": "SalaryNegotiation-module__GBaHrq__insightsSection",
  "leverageList": "SalaryNegotiation-module__GBaHrq__leverageList",
  "leverageSection": "SalaryNegotiation-module__GBaHrq__leverageSection",
  "marketRates": "SalaryNegotiation-module__GBaHrq__marketRates",
  "mistakesList": "SalaryNegotiation-module__GBaHrq__mistakesList",
  "mistakesSection": "SalaryNegotiation-module__GBaHrq__mistakesSection",
  "negotiability": "SalaryNegotiation-module__GBaHrq__negotiability",
  "negotiationChecklist": "SalaryNegotiation-module__GBaHrq__negotiationChecklist",
  "rateCard": "SalaryNegotiation-module__GBaHrq__rateCard",
  "rateCards": "SalaryNegotiation-module__GBaHrq__rateCards",
  "rateLevel": "SalaryNegotiation-module__GBaHrq__rateLevel",
  "rateRange": "SalaryNegotiation-module__GBaHrq__rateRange",
  "resourceLink": "SalaryNegotiation-module__GBaHrq__resourceLink",
  "resourceLinks": "SalaryNegotiation-module__GBaHrq__resourceLinks",
  "resourcesSection": "SalaryNegotiation-module__GBaHrq__resourcesSection",
  "scenarioBadge": "SalaryNegotiation-module__GBaHrq__scenarioBadge",
  "scriptBox": "SalaryNegotiation-module__GBaHrq__scriptBox",
  "scriptBoxHeader": "SalaryNegotiation-module__GBaHrq__scriptBoxHeader",
  "scriptCard": "SalaryNegotiation-module__GBaHrq__scriptCard",
  "scriptContent": "SalaryNegotiation-module__GBaHrq__scriptContent",
  "scriptHeader": "SalaryNegotiation-module__GBaHrq__scriptHeader",
  "scriptMeta": "SalaryNegotiation-module__GBaHrq__scriptMeta",
  "scriptText": "SalaryNegotiation-module__GBaHrq__scriptText",
  "scriptTips": "SalaryNegotiation-module__GBaHrq__scriptTips",
  "scriptsList": "SalaryNegotiation-module__GBaHrq__scriptsList",
  "subtitle": "SalaryNegotiation-module__GBaHrq__subtitle",
  "tab": "SalaryNegotiation-module__GBaHrq__tab",
  "tabIcon": "SalaryNegotiation-module__GBaHrq__tabIcon",
  "tabIntro": "SalaryNegotiation-module__GBaHrq__tabIntro",
  "tabLabel": "SalaryNegotiation-module__GBaHrq__tabLabel",
  "tabNav": "SalaryNegotiation-module__GBaHrq__tabNav",
  "tipCard": "SalaryNegotiation-module__GBaHrq__tipCard",
  "tipCategory": "SalaryNegotiation-module__GBaHrq__tipCategory",
  "tipContent": "SalaryNegotiation-module__GBaHrq__tipContent",
  "tipExample": "SalaryNegotiation-module__GBaHrq__tipExample",
  "tipHeader": "SalaryNegotiation-module__GBaHrq__tipHeader",
  "tipsGrid": "SalaryNegotiation-module__GBaHrq__tipsGrid",
  "title": "SalaryNegotiation-module__GBaHrq__title",
  "xIcon": "SalaryNegotiation-module__GBaHrq__xIcon",
});
